<ng-container *transloco="let t; prefix: scope() + '.navigation'">
  @if (displayMode() === 'menu') {
    <button
      aria-haspopup="true"
      aria-controls="menu"
      type="button"
      class="h-full text-blue-50 hover:opacity-80"
      (click)="toggleSideNav.emit()"
    >
      <span class="sr-only"> {{ t('menuTitle') }} </span>
      <rma-icon role="menu" glyph="menu" />
    </button>
  } @else {
    <div class="flex h-full items-center gap-2">
      <rma-menu [text]="t('about')" [items]="aboutItems" mode="popover" />
      <rma-menu [text]="t('solutions')" [items]="forMenuItems" mode="popover" />
    </div>
  }

  <ng-template #aboutItems>
    <div class="nc-glow-lg flex flex-col gap-2 rounded-xl bg-white p-4">
      <a rmaMenuItem [href]="story()">{{ t('story') }}</a>
      <a rmaMenuItem [href]="reviews()">{{ t('reviews') }}</a>
    </div>
  </ng-template>

  <ng-template #forMenuItems>
    <div class="nc-glow-lg flex flex-col gap-2 rounded-xl bg-white p-4">
      <a rmaMenuItem [href]="group()">{{ t('group') }}</a>
      <a rmaMenuItem [href]="agents()">{{ t('agents') }}</a>
    </div>
  </ng-template>
</ng-container>
